import Vue from 'vue';
import Router from 'vue-router';
import login from "@/views/login/login.vue"
import register from "@/views/login/register.vue"
import forgetPassword from "@/views/login/forgetPassword.vue"
import agreement from "@/views/login/agreement.vue"

import chat from "@/views/chat/chat.vue"


import index from "@/views/index/index.vue"
import APPDownload from "@/views/index/APPDownload.vue"
import navAppDownload from "@/views/index/navAppDownload.vue"



import courseCenter from "@/views/course/courseCenter.vue"
import courseDetail from "@/views/course/courseDetail.vue"
import courseChild from "@/views/course/courseChild.vue"
import subject from "@/views/course/subject.vue"
import tryOutOver from "@/views/course/tryOutOver.vue"
import tryOutExam from "@/views/course/tryOutExam.vue"
import tryOutAnalysis from "@/views/course/tryOutAnalysis.vue"


import QAZone from "@/views/QAZone/QAZone.vue" //问答专区
import QAZoneDetail from "@/views/QAZone/QAZoneDetail.vue" //问答专区详情
import newsCenter from "@/views/newsCenter/newsCenter.vue" //资讯中心
import newsDetail from "@/views/newsCenter/newsDetail.vue" //资讯中心详情



import resourceDownload from "@/views/resourceDownload/resourceDownload.vue" //资源下载
import resourceDetail from "@/views/resourceDownload/resourceDetail.vue" //资源详情
import studyCenter from "@/views/studyCenter/studyCenter.vue"
import study from "@/views/studyCenter/study/study.vue"

import newStudyCenter from "@/views/studyCenter/newStudyCenter.vue"

import videosCourse from "@/views/studyCenter/study/videosCourse.vue" //我的视频及课件
import testPaper from "@/views/studyCenter/study/testPaper.vue" //我的试卷
import exercise from "@/views/studyCenter/study/exercise.vue" //我的练习
import wrongQuestion from "@/views/studyCenter/study/wrongQuestion.vue" //我的错题
import collection from "@/views/studyCenter/study/collection.vue" //我的收藏
import questionCorrect from "@/views/studyCenter/study/questionCorrect.vue" //我的疑问/纠错
import exam from "@/views/exam/exam.vue" //考试
import examTip from "@/views/exam/examTip.vue" //考试提示
import examQuestions from "@/views/exam/examQuestions.vue" //考试




import pdf from "@/views/studyCenter/pdf.vue"

import multipleQuestions from "@/views/exam/multipleQuestions.vue" //多题型
import multipkeAnalysis from "@/views/exam/multipkeAnalysis.vue" //多题型




import examOver from "@/views/exam/examOver.vue" //考试结束
import examAnalysis from "@/views/exam/examAnalysis.vue" //考试解析
import reciteQuestionsMode from "@/views/exam/reciteQuestionsMode.vue" //背题模式
import chapterExercises from "@/views/exam/chapterExercises.vue" //章节练习
import chapterExam from "@/views/exam/chapterExam.vue" //章节答题
import chapterEnd from "@/views/exam/chapterEnd.vue" //章节答题
import chapterAnalysis from "@/views/exam/chapterAnalysis.vue" //章节练习--分析
import errorExamMode from "@/views/exam/errorExamMode.vue" //错题背题模式
import detailsQuestion from "@/views/exam/detailsQuestion.vue" //疑问详情


import personalSet from "@/views/personalCenter/personalSet.vue" //个人设置
import baseInfo from "@/views/personalCenter/baseInfo.vue" //基础信息
import myInviteCode from "@/views/personalCenter/myInviteCode.vue" //我的邀请码
import myAccount from "@/views/personalCenter/myAccount.vue" //我的问答


import updatePass from "@/views/personalCenter/updatePass.vue" //修改密码


import newSystem from "@/views/notice/newSystem.vue" //新消息列表
import notice from "@/views/notice/notice.vue" //我的通知
import system from "@/views/notice/system.vue" //系统通知

import other from "@/views/notice/other.vue" //其他通知

import otherInfo from "@/views/notice/otherInfo.vue" //其他通知
import cart from "@/views/personalCenter/cart.vue" //购物车
import orderList from "@/views/personalCenter/orderList.vue" //我的订单

import myCollect from "@/views/personalCenter/myCollect/myCollect.vue" //我的收藏
import courseCollect from "@/views/personalCenter/myCollect/courseCollect.vue" //课程收藏
import newsCollect from "@/views/personalCenter/myCollect/newsCollect.vue" //资讯收藏
import resourcesCollect from "@/views/personalCenter/myCollect/resourcesCollect.vue" //资源收藏
import myQA from "@/views/personalCenter/myQA.vue" //我的问答



Vue.use(Router);
const routes = [{
		path: '/',
		component: index,
		meta: {
			title: ''
		}
	},
	{
		path: '/APPDownload',
		component: APPDownload,
		meta: { title: '' } //下载
	},
	{

		path: '/navAppDownload',
		component: navAppDownload,
		meta: { title: '' } //下载
	},
	{
		path: '/chat',
		component: chat,
		meta: {
			title: '', //智能问答
		}
	},
	{

		path: '/QAZone',
		component: QAZone,
		meta: {
			title: '', //问答专区 
		}
	},
	{
		path: '/QAZoneDetail',
		component: QAZoneDetail,
		meta: {
			title: '', //问答专区 
		}
	},
	{
		path: '/newsCenter',
		component: newsCenter,
		meta: {
			title: '', //资讯中心 
		}
	},
	{
		path: '/newsDetail',
		component: newsDetail,
		meta: {
			title: '', //资讯详情 
		}
	},

	{
		path: '/resourceDownload',
		component: resourceDownload,
		meta: {
			title: '', //资源下载 
		}
	},
	{
		path: '/resourceDetail',
		component: resourceDetail,
		meta: {
			title: '', //资源下载详情 
		}
	},
	{
		
		path: '/pdf',
		component: pdf
	},
	{
		path: '/login',
		component: login,
		meta: {
			title: '', //登录 
		}
	},
	{
		path: '/register',
		component: register,
		meta: {
			title: '', //注册 
		}
	},
	{

		path: '/forgetPassword',
		component: forgetPassword,
		meta: {
			title: '', //忘记密码 
		}
	},
	{

		path: '/agreement',
		component: agreement,
		meta: {
			title: '', //协议 
		}
	},
	{ path: '/courseCenter', component: courseCenter },
	{ path: '/courseDetail', component: courseDetail },
	{ path: '/courseChild', component: courseChild },
	{ path: '/subject', component: subject },
	{ path: '/tryOutAnalysis', component: tryOutAnalysis },
	{ path: '/tryOutExam', component: tryOutExam },
	{ path: '/tryOutOver', component: tryOutOver },
	{
		path: '/studyCenter',
		component: studyCenter,
		children: [{
				path: 'newStudyCenter',
				component: newStudyCenter
			},
			{
				path: 'study',
				component: study,
				children: [{
						path: 'videosCourse',
						component: videosCourse
					}, {
						path: 'testPaper',
						component: testPaper
					},
					{
						path: 'exercise',
						component: exercise
					},
					{
						path: 'wrongQuestion',
						component: wrongQuestion
					},
					{
						path: 'collection',
						component: collection
					},
					{
						path: 'questionCorrect',
						component: questionCorrect,
						meta: {
							title: '', //我的疑问 
						}
					}
				]
			}


		]
	},
	{
		path: '/exam',
		component: exam,
		children: [{
				path: 'examTip',
				component: examTip
			},
			{
				path: 'examQuestions',
				component: examQuestions
			},
			{
				path: 'multipleQuestions',
				component: multipleQuestions
			},
			{
				path: 'multipkeAnalysis',
				component: multipkeAnalysis

			},
			{
				path: 'examOver',
				component: examOver
			},
			{
				path: 'examAnalysis',
				component: examAnalysis
			},
			{
				path: 'reciteQuestionsMode',
				component: reciteQuestionsMode
			},
			{
				path: 'chapterExercises',
				component: chapterExercises
			},
			{
				path: 'chapterExam',
				component: chapterExam
			},
			{
				path: 'chapterEnd',
				component: chapterEnd
			},
			{
				path: 'chapterAnalysis',
				component: chapterAnalysis
			},
			{
				path: 'errorExamMode',
				component: errorExamMode
			},
			{
				path: 'detailsQuestion',
				component: detailsQuestion

			}

		]
	},
	{

		path: '/personalCenter',
		component: studyCenter,
		children: [{
				path: 'notice',
				component: notice,
				children: [{
						path: 'newSystem',
						component: newSystem
					}, {
						path: 'system',
						component: system
					},
					{
						path: 'other',
						component: other
					},
					{
						path: 'otherInfo',
						component: otherInfo
					}
				]
			},
			{
				path: 'personalSet',
				component: personalSet,
				children: [{
						path: 'baseInfo',
						component: baseInfo
					},
					{

						path: 'myInviteCode',
						component: myInviteCode
					},
					{
						path: 'myAccount',
						component: myAccount

					}
				]
			},
			{
				path: 'updatePass',
				component: updatePass,
			},
			{
				path: 'cart',
				component: cart,

			},
			{
				path: 'orderList',
				component: orderList,

			},
			{
				path: 'myCollect',
				component: myCollect,
				children: [{
						path: 'courseCollect',
						component: courseCollect
					},
					{
						path: 'newsCollect',
						component: newsCollect

					},
					{
						path: 'resourcesCollect',
						component: resourcesCollect
					}
				]
			},
			{
				path: 'myQA',
				component: myQA,
			}
		]
	}

]

const router = new Router({ mode: 'hash', routes })
router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
});
export default router